import React from "react";
import { Mail, Phone, MapPin, User, Globe, FolderKanban } from "lucide-react";
import { useApi, fetchCustomers } from "../api";
import { PageHeader, Avatar, Loading, ErrorState } from "../components/common";

export default function Customers() {
  const { data: customers, loading, error, reload } = useApi(fetchCustomers);
  if (error) return <ErrorState message={error} onRetry={reload} />;
  if (loading || !customers) return <Loading />;

  return (
    <div className="mx-auto max-w-7xl animate-fade-in-up">
      <PageHeader title="Customers" subtitle={`${customers.length} live customer account${customers.length !== 1 ? "s" : ""}`} />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {customers.map((c) => (
          <div key={c.id} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-md">
            <div className="flex items-center gap-4">
              <Avatar avatar={{ name: c.name, initials: c.initials, color: c.color }} size={56} />
              <div className="min-w-0"><h3 className="truncate text-base font-bold text-slate-900">{c.name}</h3>{c.web && <p className="truncate text-xs text-slate-400">{c.web}</p>}</div>
              <span className="ml-auto rounded-full bg-emerald-50 px-2.5 py-1 text-[11px] font-semibold text-emerald-700">Active</span>
            </div>
            <div className="mt-5 space-y-2.5 text-sm">
              {c.contact && <div className="flex items-center gap-2.5 text-slate-600"><User className="h-4 w-4 text-slate-400" /> {c.contact}{c.title ? ` · ${c.title}` : ""}</div>}
              {c.email && <div className="flex items-center gap-2.5 text-slate-600"><Mail className="h-4 w-4 text-slate-400" /> <span className="truncate">{c.email}</span></div>}
              {c.phone && <div className="flex items-center gap-2.5 text-slate-600"><Phone className="h-4 w-4 text-slate-400" /> {c.phone}</div>}
              <div className="flex items-center gap-2.5 text-slate-600"><MapPin className="h-4 w-4 text-slate-400" /> {c.location}</div>
              {c.web && <div className="flex items-center gap-2.5 text-slate-600"><Globe className="h-4 w-4 text-slate-400" /> {c.web}</div>}
            </div>
            <div className="mt-5 flex items-center justify-between border-t border-slate-100 pt-4">
              <div className="flex items-center gap-1.5 text-sm font-semibold text-slate-700"><FolderKanban className="h-4 w-4 text-red-600" /> {c.projectsCount} projects</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
